"use client";

import { Input } from "@headlessui/react";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import Pagination from "./Pagination";
import { fetchMailRooms } from "../apiCalls/messageApi";

const SelectPatientMail = ({  user,dispatch,mailMessage }) => {
  const [search, setSearch] = useState(() => localStorage.getItem("QUERYMAIL") || ""); // ✅ initialize from storage
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(8);
  const placeholder = user?.role == 2 ? 'Zoek therapeut op' : 'Zoek patient op';

  const debouncedSearch = useCallback(
    debounce((searchQuery) => {
      localStorage.setItem("QUERYMAIL", searchQuery); // ✅ store the query
      fetchMailRooms(user,dispatch,mailMessage = null,pageSize,page,searchQuery)
    }, 300),
    []
  );

  useEffect(() => {
  
    fetchMailRooms(user,dispatch,mailMessage = null,pageSize,page,search);

  }, [page, pageSize]);

  // Add debounced search function

  return (
    <div className="w-full items-center px-1">
      <Input
        placeholder={placeholder}
        className="mt-1 block w-full rounded-lg border border-wa-border bg-wa-panel py-2 pl-3 pr-3 text-sm text-wa-text outline-none ring-0 placeholder:text-wa-muted focus:border-wa-accent focus:ring-1 focus:ring-wa-accent sm:text-sm/6"
        onChange={(event) => {
          setSearch(event.target.value);
          debouncedSearch(event.target.value);
        }}
        displayValue={(mail) =>
          mail?.receiver ||
          mail?.sender ||
          mail?.subject ||
          mail?.category
        }
      />

      <div className="mt-2">
        <Pagination
          variant="mail"
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
          pageRanges={[8, 16, 32, 64, 128, 258]}
        />
      </div>
    </div>
  );
};

export default SelectPatientMail;
